export default "__VITE_ASSET__CDkD_Baq__"